import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

type Props = {
  open: boolean;
  onClose: () => void;
};

export default function RulesModal({ onClose, open }: Props) {
  return (
    <Dialog
      onClose={onClose}
      open={open}
      fullWidth
      keepMounted
      aria-labelledby="alert-dialog-slide-title"
      aria-describedby="alert-dialog-slide-description"
    >
      <DialogTitle>Правила пасьянса «Солитер»!</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-slide-description">
          В классической версии Солитера нужно собрать все карты от Туза, двойки, тройки ... до короля.. <br />
          Нельзя двигать стопки карт, если заняты все 4 свободные ячейки. Разрешено перекладывать одну карту из колонки
          или свободной ячейки, а если нужно перенести стопку карт, это можно сделать только по одной, используя пустые
          колонки и свободные ячейки. Если у вас есть 3 пустых свободных ячейки, Вы можете перетащить стопку в 3 карты.{' '}
          <br />
          Используется стандартная колода карт (52 карты). <br />
          Раскладывается вся колода в 8 колонок, лицом вверх. Таким образом, будет четыре колонки по 7 карт и ещё четыре
          — по 6. <br />
          Также есть 4 ячейки, именуемых «домом» (справа наверху), и 4 «свободных ячейки» (слева наверху). На момент
          начала игры все они пусты. <br />
          В пасьянсе Солитер Вы можете перемещать на время карты, которые закрывают другие карты на столе. <br />
          Разрешено перекладывать одну карту из колонки или свободной ячейки:
          <ul>
            <li>
              в любую другую колонку — на следующую по старшинству карту другого цвета (например, чёрного валета —
              только на красную даму).
            </li>
            <li>
              либо на свободную ячейку, если она пуста (таким образом, каждая из свободных ячеек может хранить только
              одну карту);
            </li>
            <li>либо в пустую колонку — без ограничений;</li>
            <li>либо в «дом» — карты одной масти, начиная с туза и заканчивая королём.</li>
            <li>Пасьянс Солитер сходится, если удаётся переместить всю колоду в «дом».</li>
          </ul>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          Понятно
        </Button>
      </DialogActions>
    </Dialog>
  );
}
